import React from 'react';

import Box from '@amzn/meridian/box';
import { type BoxProps } from '@amzn/meridian/box/box';
import RadioButton from '@amzn/meridian/radio-button';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { MeasureUnitAbbreviations, type MeasureUnitValues } from 'src/services/tasks/constants';

// **** Types **** //

interface ToggleShowChildSelectorsProps extends BoxProps {
  restrictionLabel: string;
  restrictionMaxUnit: MeasureUnitValues;
  maxWeightRange: number | undefined;
  value: boolean;
  onToggleValue: (value: boolean) => void;
  isDisabled: boolean;
  /** @testOnly */
  index: number;
}

// **** Components **** //

/**
 * Default component.
 * Display the individual weight range time selectors for a Parent Weight Range type.
 */
const ToggleShowChildSelectors = ({
  restrictionLabel,
  restrictionMaxUnit,
  maxWeightRange,
  value,
  onToggleValue,
  isDisabled,
  index,
  ...boxProps
}: ToggleShowChildSelectorsProps) => {
  return (
    <Box {...boxProps}>
      {/* Title */}
      <Box spacingInset="none none 200 none" data-testid="new-jmr__weight-restriction__child-weight-ranges-header">
        <Text>
          Time Restrictions{' '}
          <Text tag="span" color="secondary">
            (Optional)
          </Text>
        </Text>
        <Text>
          Do you need to specify the maximum amount of time in hours the associate can <b>{restrictionLabel}</b> weights
          less than{' '}
          <b>
            {maxWeightRange} {MeasureUnitAbbreviations[restrictionMaxUnit]}
          </b>
          ?
        </Text>
      </Box>

      {/* Radio Buttons */}
      <Row spacingInset="none none 300 none">
        <RadioButton
          checked={!value}
          disabled={isDisabled}
          onChange={() => onToggleValue(false)}
          name="show-child-selectors__no"
          value={false}
          size="medium"
        >
          No
        </RadioButton>
        <RadioButton
          checked={value}
          disabled={isDisabled}
          onChange={() => onToggleValue(true)}
          name="show-child-selectors__yes"
          value={true}
          size="medium"
          data-testid="new-jmr__weight-restriction__child-weight-range-radio-button__yes"
          data-cy={`new-jmr__weight__restriction__child-weight-range-radio-button__yes__${index}`}
        >
          Yes
        </RadioButton>
      </Row>
    </Box>
  );
};

// **** Components **** //

export default ToggleShowChildSelectors;
